module.exports = __webpack_public_path__ + "assets/images/25.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/25.png
// module id = 1289
// module chunks = 1